import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminUserFormComponent } from './component/user/form/form.component';
import { AdminRoutes } from './admin.routes';
import { LayoutModule } from '../../layout/layout.module';
import { SharedModule } from '../../shared/shared.module';
import { CampaignUtilModule } from '../campaign-util/campaign-util.module';
import { BreadcrumbModule } from '../../shared/ui/breadcrumb/breadcrumb.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CustomerForm } from './component/customer/form/customer.form';
import { CampaignForm } from './component/campaign/form/campaign.form';
import { AdminCampaignFormComponent } from './component/campaign/form/form.component';
import { AdminCampaignListComponent } from './component/campaign/list/list.component';
import { AdminCustomerFormComponent } from './component/customer/form/form.component';
import { AdminCustomerListComponent } from './component/customer/list/list.component';
import { AdminPaymentListComponent } from './component/payment/list/list.component';
import { AdminPaymentDetailsComponent } from './component/payment/details/details.component';
import { AdminUserListComponent } from './component/user/list/list.component';
import { AdminComponent } from './component/admin.component';
import { AdminPhotocodeTemplateListComponent } from './component/photocode-template/list/list.component';
import { AdminPhotocodeTemplateFormComponent } from './component/photocode-template/form/form.component';
import { PhotocodeTemplateForm } from './component/photocode-template/form/photocode-template.form';
import { AdminMailTemplateListComponent } from './component/mail-template/list/list.component';
import { AdminMailTemplateFormComponent } from './component/mail-template/form/form.component';
import { MailTemplateSendForm } from './component/mail-template/send/send.form';
import { AdminLicenseListComponent } from './component/license/list/list.component';
import { AdminLicensePricingListComponent } from './component/license-pricing/list/list.component';
import { AdminLicenseFormComponent } from './component/license/form/form.component';
import { AdminLicensePricingFormComponent } from './component/license-pricing/form/form.component';
import { LicenseForm } from './component/license/form/license.form';
import { LicensePricingForm } from './component/license-pricing/form/license-pricing.form';
import { AdminCustomerLicenseComponent } from './component/customer/license/license.component';
import { CustomerLicenseForm } from './component/customer/license/license.form';
import { TemplateForm } from './component/mail-template/form/template.form';
import { AdminJobListComponent } from './component/job/list/list.component';
import { ClipboardModule } from 'ngx-clipboard';
import { AdminCustomerTabsComponent } from './component/customer/tabs/tabs.component';
import { AdminCustomerCampaignListComponent } from './component/customer/campaign/campaign.component';
import { AdminCustomerUserListComponent } from './component/customer/user/list.component';
import { AdminCustomerUserFormComponent } from './component/customer/user/form.component';
import { AdminCustomerUserComponent } from './component/customer/user/user.component';
import { CustomerUserForm } from './component/customer/user/user.form';
import { CustomerPaymentForm } from './component/customer/payment/payment.form';
import { AdminCustomerPaymentComponent } from './component/customer/payment/payment.component';
import { AdminCustomerInvoicesComponent } from './component/customer/invoices/invoices.component';
import { AdminCustomerInvoiceComponent } from './component/customer/invoice/invoice.component';
import { CustomerInvoiceForm } from './component/customer/invoice/invoice.form';
import { AdminCustomerPhotographerListComponent } from './component/customer/user/photographers.component';
import { AdminProductFormComponent } from './component/product/form.component';
import { AdminProductListComponent } from './component/product/list.component';
import { AdminProductForm } from './component/product/product.form';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AdminCampaignSettingsComponent } from './component/customer/campaign/settings.component';
import { CampaignStatsComponent } from './component/campaign-stats/campaign-stats.component';
import { AdminPhotographerFormComponent } from './component/photographer/form/form.component';
import { AdminPhotographerListComponent } from './component/photographer/list/list.component';
import { PhotographerForm } from './component/photographer/form/photographer.form';
import { WebsiteRedirectListComponent } from './component/website-redirect/list/list.component';
import { WebsiteRedirectAddFormComponent } from './component/website-redirect/form-add/form-add.component';
import { WebsiteRedirectAddForm } from './component/website-redirect/form-add/website-redirect-add.form';
import { AdminSolvimonEventListComponent } from './component/solvimon-event/list/list.component';
import { AdminSolvimonEventFormComponent } from './component/solvimon-event/form/form.component';
import { SolvimonEventForm } from './component/solvimon-event/form/solvimon-event.form';
import { SolvimonTabsComponent } from './component/solvimon-tabs/solvimon-tabs.component';
import { AdminApiAccessTokenComponent } from './component/photographer/api-access-token/api-access-token.component';
import { AdminApiKeyFormComponent } from './component/apikey/form/form.component';
import { ApiKeyForm } from './component/apikey/form/apikey.form';
import { AdminApiKeyListComponent } from './component/apikey/list/list.component';
import { FormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { AdminCustomeCameraSettingsTableComponent } from './component/customer/camera-settings/table.component';
import { CustomerCameraSettingsForm } from './component/customer/camera-settings/camera-settings.form';
import { AdminInventoryComponent } from './component/invetory/component/inventory.component';
import { AdminInventoryListComponent } from './component/invetory/component/inventory-list/inventory-list.component';
import { AdminInventoryListDatatableComponent } from './component/invetory/component/inventory-list/datatable/inventory-list-datatable.component';
import { AdminInventoryAddProductModal } from './component/invetory/modals/inventory-add-product/inventory-add-product.component';
import { InventoryGreySelectComponent } from './component/invetory/modals/inventory-grey-select/inventory-grey-select.component';
import { InventoryEditStockModal } from './component/invetory/modals/inventory-datatable-edit/inventory-datatable-edit.component';
import { InventoryUpdateStockModal } from './component/invetory/modals/inventory-datatable-update/inventory-datatable-update.component';
import { ProductAddForm } from './component/invetory/modals/inventory-add-product/inventory-add.form';
import { ProductEditForm } from './component/invetory/modals/inventory-datatable-edit/inventory-edit.form';
import { AdminPrintCreditListComponent } from './component/print-credit/component/print-credit-list/print-credit-list.component';
import {
    AdminPrintCreditListDatatableComponent
} from './component/print-credit/component/print-credit-list/datatable/print-credit-list-datatable.component';
import { AdminPrintCreditFormModal } from './component/print-credit/modals/print-credit-form/print-credit-form.component';
import { AdminPrintCreditComponent } from './component/print-credit/component/print-credit.component';
import { AdminPrintTemplateListComponent } from './component/print-template/list/list.component';
import { AdminPrintTemplateEditorComponent } from './component/print-template/editor/editor.component';
import { PrintCreditForm } from './component/print-credit/modals/print-credit-form/print-credit-form.form';

@NgModule({
    declarations: [
        AdminComponent,
        AdminApiKeyListComponent,
        AdminApiKeyFormComponent,
        AdminCampaignFormComponent,
        AdminCampaignListComponent,
        AdminCustomerFormComponent,
        AdminCustomerListComponent,
        AdminPaymentListComponent,
        AdminPaymentDetailsComponent,
        AdminUserFormComponent,
        AdminUserListComponent,
        AdminPhotocodeTemplateFormComponent,
        AdminPhotocodeTemplateListComponent,
        AdminMailTemplateFormComponent,
        AdminMailTemplateListComponent,
        AdminLicenseListComponent,
        AdminLicenseFormComponent,
        AdminLicensePricingListComponent,
        AdminLicensePricingFormComponent,
        AdminCustomerLicenseComponent,
        AdminJobListComponent,
        AdminCustomerTabsComponent,
        AdminCustomerCampaignListComponent,
        AdminCustomerUserListComponent,
        AdminCustomerUserFormComponent,
        AdminCustomerUserComponent,
        AdminCustomerPaymentComponent,
        AdminCustomerInvoicesComponent,
        AdminCustomerInvoiceComponent,
        AdminCustomerPhotographerListComponent,
        AdminProductFormComponent,
        AdminProductListComponent,
        AdminPhotographerFormComponent,
        AdminPhotographerListComponent,
        AdminCampaignSettingsComponent,
        CampaignStatsComponent,
        AdminSolvimonEventListComponent,
        AdminSolvimonEventFormComponent,
        SolvimonTabsComponent,
        WebsiteRedirectListComponent,
        WebsiteRedirectAddFormComponent,
        AdminApiAccessTokenComponent,
        AdminCustomeCameraSettingsTableComponent,
        AdminInventoryComponent,
        AdminInventoryListComponent,
        AdminInventoryListDatatableComponent,
        AdminInventoryAddProductModal,
        InventoryEditStockModal,
        InventoryGreySelectComponent,
        AdminPrintCreditComponent,
        AdminPrintCreditListComponent,
        AdminPrintCreditListDatatableComponent,
        AdminPrintCreditFormModal,
        AdminPrintTemplateListComponent,
        AdminPrintTemplateEditorComponent
    ],
    entryComponents: [
        AdminUserFormComponent,
        AdminCampaignFormComponent,
        AdminApiAccessTokenComponent,
        AdminInventoryAddProductModal,
        InventoryEditStockModal,
        InventoryUpdateStockModal,
        AdminPrintCreditFormModal
    ],
    exports: [],
    imports: [
        RouterModule.forChild(AdminRoutes),
        LayoutModule,
        SharedModule,
        CampaignUtilModule,
        BreadcrumbModule,
        ModalModule.forRoot(),
        ClipboardModule,
        DragDropModule,
        FormsModule,
        QRCodeModule,
    ],
    providers: [
        CustomerUserForm,
        CustomerForm,
        CampaignForm,
        PhotocodeTemplateForm,
        MailTemplateSendForm,
        LicenseForm,
        LicensePricingForm,
        CustomerLicenseForm,
        TemplateForm,
        CustomerPaymentForm,
        CustomerInvoiceForm,
        AdminProductForm,
        PhotographerForm,
        WebsiteRedirectAddForm,
        SolvimonEventForm,
        ApiKeyForm,
        CustomerCameraSettingsForm,
        ProductAddForm,
        ProductEditForm,
        PrintCreditForm,
    ],
})
export class AdminModule {}
